import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getUserSubscription } from "../apis/subscription";
import SubscriptionInline from "./SubscriptionInline";

// Define routes that require subscription
const PROTECTED_ROUTES = [
  '/broadcast',
  '/flows/builder', // This will match /flows/builder/:flowId as well
  '/flow-list'
];

// Check if current path requires subscription
const isProtectedRoute = (pathname) => {
  return PROTECTED_ROUTES.some(route => {
    if (route === '/flows/builder') {
      return pathname.startsWith('/flows/builder');
    }
    return pathname === route;
  });
};

const SubscriptionGate = ({ children, requiredFeature = null }) => {
  const [hasSubscription, setHasSubscription] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkSubscription();
  }, []);

  // Re-check subscription when route changes
  useEffect(() => {
    if (isProtectedRoute(location.pathname)) {
      checkSubscription();
    }
  }, [location.pathname]);

  const checkSubscription = async () => {
    try {
      setLoading(true);
      const response = await getUserSubscription();
      if (response.data.success && response.data.data) {
        const subscription = response.data.data;
        const expiresAt = new Date(subscription.expires_at);
        const isExpired = expiresAt < new Date();
        
        if (!isExpired) {
          setHasSubscription(true);
        } else {
          setHasSubscription(false);
        }
      } else {
        setHasSubscription(false);
      }
    } catch (error) {
      console.error("Error checking subscription:", error);
      setHasSubscription(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSubscriptionSuccess = () => {
    setHasSubscription(true);
    window.location.reload();
  };

  // Show loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-12 h-12 border-4 border-gray-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // If has subscription, show children
  if (hasSubscription) {
    return <>{children}</>;
  }

  // If no subscription, show inline subscription UI (more secure - can't be bypassed)
  return <SubscriptionInline onSuccess={handleSubscriptionSuccess} />;
};

export default SubscriptionGate;

